import { cn } from '@/utilities/ui'
import * as React from 'react'

// Figma Field "Vertical" (node 2198:38543): label + input stacked in a flex column
// with gap-2 (8px) between the label and the input.
export const Width: React.FC<{
  children: React.ReactNode
  className?: string
  width?: number | string
}> = ({ children, className }) => {
  return (
    <div className={cn('flex flex-col gap-2', className)}>
      {children}
    </div>
  )
}
